'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefault(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefault(_objectWithoutProperties);

var _excluded = ["title"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty__default.default(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var QuestionIcon = function QuestionIcon(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Question' : _ref$title,
    props = _objectWithoutProperties__default.default(_ref, _excluded);
  return /*#__PURE__*/jsxRuntime.jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    title: title,
    role: "img"
  }, props), {}, {
    children: [/*#__PURE__*/jsxRuntime.jsx("title", {
      children: title
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M14.7975 5.46787C15.64 5.76051 16.3543 6.2761 16.8386 6.94119C17.4275 7.76782 17.5963 8.76857 17.3049 9.70675C17.1211 10.3529 16.6697 10.8729 16.1348 11.338C15.6881 11.7041 15.2105 12.0407 14.7055 12.3448C14.3396 12.5766 13.9817 12.82 13.6257 13.0692C13.3841 13.2485 13.1994 13.4784 13.0891 13.737C12.9988 13.9214 12.9097 14.1064 12.8218 14.2917C12.6212 14.7379 12.2166 14.9409 11.6866 14.9698C11.3621 15.0069 11.0326 14.9504 10.7488 14.809C10.2797 14.5549 10.0094 14.098 10.045 13.6197C10.0634 13.0379 10.3317 12.483 10.7972 12.0638C11.2036 11.6637 11.6856 11.3398 12.1674 11.0161C12.298 10.9283 12.4286 10.8405 12.5576 10.7513C13.0269 10.456 13.4316 10.0905 13.7527 9.67198C14.1923 9.0418 14.0554 8.00598 13.3064 7.54675C13.0357 7.38174 12.7255 7.27222 12.3987 7.22658C11.901 7.14589 11.3883 7.17081 10.9042 7.29902C10.3426 7.45258 9.98315 7.80606 9.71903 8.24646C9.66188 8.34204 9.6065 8.43866 9.55109 8.53533C9.42013 8.76382 9.28901 8.99258 9.13395 9.2084C8.76285 9.72688 8.14267 9.84003 7.51915 9.74151C7.24717 9.70457 6.99392 9.59809 6.79198 9.43584C6.52101 9.2055 6.37892 8.88476 6.40249 8.55648C6.41235 7.99656 6.61546 7.452 6.98606 6.99335C7.60808 6.21844 8.49138 5.6294 9.51509 5.30707C10.199 5.0789 10.9238 4.95619 11.6565 4.94489C12.7337 4.93113 13.8028 5.10903 14.7975 5.46787ZM9.76002 17.6573C9.76002 16.8051 10.5122 16.1143 11.4399 16.1143C12.3679 16.1143 13.12 16.8051 13.12 17.6573C13.12 18.5092 12.3679 19.2 11.4399 19.2C10.5122 19.2 9.76002 18.5092 9.76002 17.6573Z"
    })]
  }));
};
QuestionIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "QuestionIcon",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Question'",
        "computed": false
      },
      "required": false
    }
  }
};
var QuestionIcon$1 = QuestionIcon;

exports.default = QuestionIcon$1;
//# sourceMappingURL=QuestionIcon.js.map
